import { Box, Modal } from "@mui/material";

const ImageModel = ({ currentImage, open, handleClose, description }) => {
    console.log(currentImage);
    const isValidArray = (images) => Array.isArray(images) && images.some((img) => img.trim() !== "");

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // justifyContent: "center",
                    overflowY: "scroll",
                    maxHeight: "80vh",

                }}
            >
                {typeof currentImage === "string" && currentImage.trim() !== "" ? (
                    // Display single image if currentImage is a non-empty string
                    <Box
                        component="img"
                        alt="Preview"
                        src={currentImage}
                        sx={{
                            maxWidth: { xs: "300px", md: "80vw" },
                            minWidth: { xs: "150px", md: "500px" },
                            maxHeight: "80vh",
                            objectFit: "contain",
                            mb: 2,
                        }}
                    />
                ) : isValidArray(currentImage) ? (
                    // Display multiple images if currentImage is a valid array
                    currentImage.map(
                        (img, index) =>
                            img.trim() !== "" && (
                                <Box
                                    key={index}
                                    component="img"
                                    alt={`Preview ${index + 1}`}
                                    src={img}
                                    sx={{
                                        maxWidth: { xs: "300px", md: "60vw" },
                                        minWidth: { xs: "150px", md: "500px" },
                                        maxHeight: "40vh",
                                        objectFit: "contain",
                                        mb: 2,
                                    }}
                                />
                            )
                    )
                ) : (
                    // Display fallback message if no valid image is provided
                    <Box sx={{ textAlign: "center", p: 2,}}>
                        {description}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default ImageModel;
